import { render, staticRenderFns } from "./broker-whatsapp.vue?vue&type=template&id=5f8c7d8b"
import script from "./broker-whatsapp.vue?vue&type=script&lang=js"
export * from "./broker-whatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports